import { useEffect, useMemo } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { GoogleMapsOverlay } from '@deck.gl/google-maps';

const DeckGlOverlay = ({ layers, onDeckReady }) => {
  const deck = useMemo(() => new GoogleMapsOverlay({ interleaved: true }), []);
  const map = useMap();

  // Notify parent when deck is ready
  useEffect(() => {
    if (onDeckReady) {
      onDeckReady(deck);
    }
  }, [deck, onDeckReady]);

  useEffect(() => {
    if (map) deck.setMap(map);
    return () => deck.setMap(null);
  }, [map, deck]);

  useEffect(() => {
    deck.setProps({ layers });
  }, [deck, layers]);

  return null;
};

export default DeckGlOverlay; 